import { createAsyncMutation } from '@/utils/async';

export const SET_MEETING_DATA = 'SET_MEETING_DATA';
export const GET_PLANNINGS = createAsyncMutation('GET_PLANNINGS');

export default {
  SET_MEETING_DATA,
  GET_PLANNINGS,
};
